// Definimos a versão da api que está sendo utilizada em todas as requisições
import { version } from './config';

export default {
  baixarPdfDiario({diarioId, paginaDiario}) {
    return axios({
      url: `/api/${version}/diarios/${diarioId}/pdf/pagina/${paginaDiario}/baixar`,
      method: 'GET',
      responseType: 'arraybuffer',
      headers: {
        'Accept': 'application/pdf'
      }
    });
  }
}
